const APP_PREFIX = 'rmail-ui'

export const LocalStorageKeys = {
  DARK_MODE: `${APP_PREFIX}-dark-mode`,
  MESSAGE_DEBUG_PANELS: `${APP_PREFIX}-message-debug-panels`,
}
